
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/prueba-gratis",
      function () {
        return require("private-next-pages/business/prueba-gratis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/prueba-gratis"])
      });
    }
  